<!-- Creates a layout with a left-positioned sidenav and explicit content. -->
<!--<app-oauth (onOauthLoad)="loadApp()" spinner></app-oauth>-->
<app-oauth #oauth (onOauthLoad)="loadApp()" rootContext="/" [serverless]="true" [serverlessConfig]="oauthConfig"></app-oauth>

<div class="w-100 h-100 parent-container overflow-hidden" style="max-width: 100%">
    <div class="w-100 h-100 td-content-container">
        <app-header></app-header>
        <div class="w-100 h-100 loader-parent" style="overflow: hidden;">
            <router-outlet></router-outlet>
            <div class="loader-second-child" [ngClass]="{ overlay: isLoading }">
                <div class="loader"></div>
            </div>
        </div>
    </div>
</div>

